/**
 * xml 中特殊字符过滤
 * 参考 https://developers.google.com/search/docs/advanced/sitemaps/build-sitemap#sitemap-encoding-guidelines
 */
export const escapeSpecialXmlCharacter = (content: string): string =>
  content
    .replace(/&/g, '&amp;')
    .replace(/'/g, '&apos;')
    .replace(/"/g, '&quot;')
    .replace(/>/g, '&gt;')
    .replace(/</g, '&lt;');

export const unescapeSpecialXmlCharacter = (content: string): string =>
  content
    .replace(/&amp;/g, '&')
    .replace(/&apos;/g, "'")
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<');

export const removeEscapedSpecialXmlCharacter = (content: string): string =>
  content.replace(/&(lt|gt|nbsp|amp|quot);/gi, '');
